import type { ReactNode } from 'react';
import { MetricsState } from './MetricsState';
import type { MetricsBlockStateProps } from './types';

interface MetricBlockProps extends MetricsBlockStateProps {
  title: string;
  description?: string;
  isEmpty?: boolean;
  children: ReactNode;
}

export function MetricBlock({ title, description, isLoading, error, isEmpty, emptyMessage, children }: MetricBlockProps) {
  return (
    <section className="bi-panel">
      <div>
        <h2 className="text-lg font-semibold text-gray-950 dark:text-white">{title}</h2>
        {description && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>}
      </div>
      <div className="mt-5">
        {isLoading && <MetricsState variant="loading" />}
        {!isLoading && error && <MetricsState variant="error" message={error} />}
        {!isLoading && !error && isEmpty && <MetricsState variant="empty" message={emptyMessage} />}
        {!isLoading && !error && !isEmpty && children}
      </div>
    </section>
  );
}
